import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsForYouEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-assets-for-you-page-entrypoint" */ './index.tsx').then(
			(module) => module.AssetsForYouPageView,
		),
	),
	getPreloadProps: () => ({}),
});
